"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M10.491 5.048C9.296 2.118 5.181.808 2.627 3.36A3.879 3.879 0 001.5 6.088c0 1.06.434 2.024 1.127 2.728a3.838 3.838 0 002.728 1.127c.915 0 1.744-.337 2.409-.867-.145 1.889-2.13 3.585-3.21 3.845l.502 1.561a8.792 8.792 0 004.52-2.611c1.349-1.465 1.917-4.356.915-6.823zm11.5 0c-1.195-2.93-5.31-4.24-7.864-1.687A3.879 3.879 0 0013 6.088c0 1.06.434 2.024 1.127 2.728a3.838 3.838 0 002.728 1.127c.915 0 1.744-.337 2.409-.867-.145 1.889-2.13 3.585-3.21 3.845l.502 1.561a8.792 8.792 0 004.52-2.611c1.349-1.465 1.917-4.356.915-6.823zM22 20H2v2h20v-2z" }), "Quote");
//# sourceMappingURL=Quote.js.map